<template>
<div class="auction-filter">
    <div class="trigger" :class="{black: isLightHigh}" @click="openModal">
        <img v-if="!isLightHigh" src="../../../assets/img/preview/filter.png" alt="">
        <img v-else src="../../../assets/img/preview/filter-black.png" alt="">
        筛选
    </div>

    <!--搜索-->
    <van-action-sheet class="auction-filter-popup" :class="{level: showAllType}" v-model="show" :close-on-click-overlay="false" get-container="body">
        <div class="title">
            <div class="text">筛选</div>
            <div class="close" @click="closeModal">×</div>
        </div>
        <div class="scroll-content">
            
            <div class="group">
                <div class="group-title">
                    <div class="text">类型</div>
                </div>
                <div class="group-items">
                    <div class="item" :class="{active: isExist(item.type, 'auction_typeList')}" @click="toggleSelect(item.name, item.type, 'auction_typeList')" v-for="item in auction_typeList" :key="item.name">
                        {{ item.name }}
                    </div>
                    <div class="item no-data" v-for="n in 2" :key="'nodata-'+n"></div>
                </div>
            </div>
            <div class="group">
                <div class="group-title">
                    <div class="text">拍品分类</div>
                </div>
                <div class="group-items">
                    <div class="item" :class="{active: isExist(item.code, 'online_auction')}" @click="toggleSelect(item.name, item.code, 'online_auction')" v-for="item in auction_type" :key="item.code">
                        {{ item.name }}
                    </div>
                    <div class="item no-data" v-for="n in 2" :key="'nodata-'+n"></div>
                </div>
            </div>
            <div class="group">
                <div class="group-title">
                    <div class="text">拍行</div>
                    <div class="all" v-if="type === 3" @click="openAllModal('organ_list')">全部</div>
                </div>
                <div class="group-items">
                    <div class="item" :class="{active: isExist(item.code, 'organ_code')}" @click="toggleSelect(item.name, item.code, 'organ_code')" v-for="item in recommend_organ_list" :key="item.code">
                        {{ item.name }}
                    </div>
                    <div class="item no-data" v-for="n in 2" :key="'nodata-'+n"></div>
                </div>
            </div>
            <div class="group">
                <div class="group-title">
                    <div class="text">城市</div>
                    <div class="all" v-if="type === 3" @click="openAllModal('cityList')">全部</div>
                </div>
                <div class="group-items">
                    <div class="item" :class="{active: isExist(item.code, 'city')}" @click="toggleSelect(item.name, item.code, 'city')" v-for="item in recommend_city_list" :key="item.code">
                        {{ item.name }}
                    </div>
                    <div class="item no-data" v-for="n in 2" :key="'nodata-'+n"></div>
                </div>
            </div>
            <div class="group">
                <div class="group-title">
                    <div class="text">拍卖时间</div>
                </div>
                <div class="group-items">
                    <div class="item" :class="{active: isExist(item.date, 'auction_date')}" @click="toggleSelect(item.name, item.date, 'auction_date')" v-for="item in auction_date" :key="item.date">
                        {{ item.name }}
                    </div>
                    <div class="item no-data" v-for="n in 2" :key="'nodata-'+n"></div>
                </div>
            </div>
        </div>
        <div class="bottom" :class="{more: selected.length}">
            <div class="selected-tags" v-show="selected.length">
                <div class="tag-items">
                    <div class="tag-items-content">
                        <div class="tag-item" v-for="item in selected" :key="item.type + item.value">
                            <div class="text">{{ item.label }}</div>
                            <div class="close" @click="toggleSelect(item.label, item.value, item.type)">×</div>
                        </div>
                    </div>
                </div>
                <div class="del" @click="reset">
                    <img src="../../../assets/img/preview/del.png" alt="">
                    <span>清除</span>
                </div>
            </div>
            <van-button :disabled="!resTotal" color="#000" block round type="info" @click="save">查看 {{ resTotal }}
                个结果
            </van-button>
        </div>
    </van-action-sheet>

    <!--某一属性的全部搜索-->
    <van-action-sheet class="auction-filter-popup" v-model="showAllType" :close-on-click-overlay="false" get-container="body">
        <div class="title">
            <div class="text">{{ allTitle }}</div>
            <div class="close" @click="closeAllModal">×</div>
        </div>
        <div class="scroll-content-all">
            <van-index-bar :class="{isMove: showTip}" :indexList="indexList" @change="indexChange">
                <div v-for="(item, index) in renderList" :key="item.l">
                    <template v-if="index === 0">
                        <van-index-anchor :index="item.l[0]" />
                        <div class="recommend">
                            <div class="recommend-title">{{ item.l }}</div>
                            <div class="recommend-items">
                                <div class="item" @click="toggleAllSelect(option.name, option.code)" :class="{active: isAllExist(option.code)}" v-for="option in item.list" :key="option.code">
                                    {{ option.name }}
                                </div>
                                <div class="item no-data" v-for="n in 3" :key="'nodata-'+n"></div>
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <van-index-anchor :index="item.l" />
                        <div class="radio-item" @click="toggleAllSelect(option.name, option.code)" v-for="option in item.list" :key="option.code">
                            <div class="img" :class="{active: isAllExist(option.code)}">
                                <img class="icon-active" src="../../../assets/img/preview/radio-icon-active.png" alt="">
                                <img class="icon" src="../../../assets/img/preview/radio-icon.png" alt="">
                            </div>
                            <span>{{ option.name }}</span>
                        </div>
                    </template>
                </div>
                <transition name="van-fade">
                    <div class="index-tip" v-show="showTip">{{ currentIndex }}</div>
                </transition>
            </van-index-bar>
        </div>
        <div class="bottom">
            <div class="selected-tags" v-show="allSelected.length">
                <div class="tag-items">
                    <div class="tag-items-content">
                        <div class="tag-item" v-for="item in allSelected" :key="item.value">
                            <div class="text">{{ item.label }}</div>
                            <div class="close" @click="toggleAllSelect(item.label, item.value)">×</div>
                        </div>
                    </div>
                </div>
                <div class="del" @click="resetAll">
                    <img src="../../../assets/img/preview/del.png" alt="">
                    <span>清除</span>
                </div>
            </div>
            <van-button :disabled="!allSelected.length" color="#000" block round type="info" @click="saveAll">确定
            </van-button>
        </div>
    </van-action-sheet>
</div>
</template>

<script>
import {
    searchLotList,
    searchOptions
} from '@/api/preview'

export default {
    name: 'AuctionFilter',
    props: {
        type: {
            type: Number,
            required: true
        },
        isLightHigh: {
            type: Boolean,
            required: false
        }
    },
    data() {
        return {
            // 数据
            auction_type: [],
            recommend_organ_list: [],
            auction_typeList: [],
            recommend_city_list: [],
            auction_date: [],
            cityList: [],
            organ_list: [],

            show: false,
            selected: [],
            realSelected: [],
            resTotal: 0,

            showAllType: false,
            allTitle: '',
            renderList: [],
            indexList: [],
            allSelected: [],
            currentIndex: '',
            showTip: false
        }
    },
    methods: {
        isExist(value, type) {
            return !!this.selected.find(i => i.type === type && i.value === value)
        },
        toggleSelect(label, value, type) {
            let index = this.selected.findIndex(i => i.type === type && i.value === value)
            if (index === -1) {
                this.selected.push({
                    label,
                    value,
                    type
                })
            } else {
                this.selected.splice(index, 1)
            }
            if (this.selected.length) {
                this.getData()
            } else {
                this.resTotal = 0
            }
        },
        reset() {
            this.selected = []
            this.resTotal = 0
            // this.getData()
        },
        openModal() {
            this.show = true
            console.log("this.selected222222222222222222222222222222")
            console.log(this.selected)
            this.selected = [...this.realSelected]
            if (this.selected.length) {
                this.getData()
            }
        },
        closeModal() {
            this.show = false
            this.selected = []
            this.resTotal = 0
        },
        save() {
            this.realSelected = [...this.selected]

            if (this.realSelected.length) {
                let online_auction = []
                let organ_code = []
                let city = []
                let auction_date = []
                let auction_typeList = []
                

                this.realSelected.forEach(item => {
                    if (item.type === 'online_auction') {
                        online_auction.push(item.value)
                    } else if (item.type === 'organ_code') {
                        organ_code.push(item.value)
                    } else if (item.type === 'city') {
                        city.push(item.value)
                    } else if (item.type === 'auction_date') {
                        auction_date.push(item.value)
                    }else if (item.type === 'auction_typeList') {
                        auction_typeList.push(item.value)
                    }
                })

                let params = {
                    classCode: [0, 2].includes(online_auction.length) ? '' : online_auction[0],
                    organ_code: organ_code.join(','),
                    city: city.join(','),
                    auction_date: auction_date.join(','),
                    online_auction: auction_typeList.join(','),
                }

                this.$emit('search', params)
            } else {
                this.$emit('search', null)
            }

            this.closeModal()
        },

        openAllModal(type) {
            if (type === 'organ_list') {
                this.allTitle = '拍行'
            } else if (type === 'cityList') {
                this.allTitle = '城市'
            }
            let map = {
                organ_list: 'organ_code',
                cityList: 'city'
            }
            this.allSelected = this.selected.filter(i => i.type === map[type])
            this.renderList = this[type]
            this.indexList = this[type].map((i, index) => index === 0 ? i.l[0] : i.l)

            this.showAllType = true
            this.$nextTick(() => {
                let el = document.querySelector('.van-index-bar__sidebar')
                el.ontouchstart = () => {
                    this.showTip = true
                }
                document.ontouchend = () => {
                    setTimeout(() => {
                        this.showTip = false
                    }, 500)
                }
            })
        },
        closeAllModal() {
            this.showAllType = false
            this.allTitle = ''
            this.renderList = []
            this.indexList = []
            this.allSelected = []
            this.currentIndex = ''
            this.showTip = false
        },
        isAllExist(value) {
            return !!this.allSelected.find(i => i.value === value)
        },
        toggleAllSelect(label, value) {
            let index = this.allSelected.findIndex(i => i.value === value)
            if (index === -1) {
                this.allSelected.push({
                    label,
                    value
                })
            } else {
                this.allSelected.splice(index, 1)
            }
        },
        resetAll() {
            this.allSelected = []
        },
        indexChange(index) {
            this.$nextTick(() => {
                let el = document.querySelector('.van-index-bar__index--active')
                let tipEl = document.querySelector('.index-tip')
                if (el && tipEl) {
                    let {
                        top,
                        height
                    } = el.getClientRects()[0]
                    tipEl.style.transform = `translateY(${top + height / 2}px)`
                }
                this.currentIndex = index
            })
        },
        saveAll() {
            let type = this.allTitle === '拍行' ? 'organ_code' : 'city'
            let newData = this.allSelected.map(item => ({
                ...item,
                type
            }))
            this.selected = this.selected.filter(i => i.type !== type).concat(newData)
            this.closeAllModal()
            this.getData()
        },

        // 获取数据
        getData() {
            this.$toast.loading({
                message: '加载中...',
                forbidClick: true,
                duration: 0
            })

            let online_auction = []
            let organ_code = []
            let city = []
            let auction_date = []
            let auction_typeList = []

            this.selected.forEach(item => {
                if (item.type === 'online_auction') {
                    online_auction.push(item.value)
                } else if (item.type === 'organ_code') {
                    organ_code.push(item.value)
                } else if (item.type === 'city') {
                    city.push(item.value)
                } else if (item.type === 'auction_date') {
                    auction_date.push(item.value)
                }else if (item.type === 'auction_typeList') {
                    auction_typeList.push(item.value)
                }
                
            })

            let params = {
                classCode: online_auction.join(','),
                organ_code: organ_code.join(','),
                city: city.join(','),
                auction_date: auction_date.join(','),
                online_auction: auction_typeList.join(','),
            }
            searchLotList({
                is_search: 1,
                special_type: this.type,
                ...params
            }).then(res => {
                if (res.code === 0) {
                    if (res.data.count) {
                        this.resTotal = res.data.count
                    } else {
                        this.resTotal = 0
                    }
                }
                this.$toast.clear()
            })
        },

        saveTemp() {
            let data = {
                realSelected: this.realSelected,
                selected: this.selected,
                resTotal: this.resTotal
            }
            sessionStorage.setItem('_filter_', JSON.stringify(data))
        }
    },
    mounted() {
        let that = this;
        if (sessionStorage._filter_ && ['previewSearchUpcoming', 'previewSearchResult'].includes(this.$route.name)) {
            let data = JSON.parse(sessionStorage.getItem('_filter_'))
            this.realSelected = data.realSelected
            this.selected = data.selected
            this.resTotal = data.resTotal
        }
        searchOptions({
            is_search: 1,
            special_type: this.type
        }).then(res => {
            if (res.code === 0) {
                this.auction_typeList= res.data.auction_type
                this.auction_type = res.data.auction_class
                this.auction_type.map((item) => {
                    if (item.curr == 1) {
                        that.selected.push({
                            label: item.name,
                            value: item.code,
                            type: 'online_auction'
                        })

                    }
                })
                this.realSelected = [...this.selected]
                this.recommend_organ_list = res.data.recommend_organ_list
                this.recommend_city_list = res.data.recommend_city_list.map(item => ({
                    name: item.name,
                    code: item.name
                }))
                this.auction_date = res.data.auction_date
                this.cityList = res.data.city_list.map(city => {
                    return {
                        l: city.l,
                        list: city.list.map(i => {
                            return {
                                name: i.name,
                                code: i.name
                            }
                        })
                    }
                })
                this.organ_list = res.data.organ_list
            }
        })
    }
}
</script>

<style lang="scss">
.auction-filter-popup {
    border-radius: 0.5rem 0.5rem 0 0;
    max-height: 100%;
    user-select: none;
    transition: all .3s;

    .van-action-sheet__content {
        position: relative;

        .title {
            width: 100%;
            height: 2.95rem;
            border-bottom: 0.02rem solid rgba(60, 60, 67, 0.36);
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 .8rem;

            .text {
                font-size: 1rem;
                font-family: PingFang SC-Medium, PingFang SC;
                font-weight: 500;
                color: #000000;
            }

            .close {
                width: 1.5rem;
                height: 1.5rem;
                background: rgba(118, 118, 128, 0.12);
                border-radius: 50%;
                font-size: 1.2rem;
                font-family: SF Pro-Semibold, SF Pro;
                font-weight: 600;
                color: rgba(60, 60, 67, 0.6);
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }

        .scroll-content {
            width: 100%;
            height: 80vh;
            overflow-y: auto;
            overflow-x: hidden;
            padding: .2rem .8rem 5.9rem;

            .group {
                margin-top: 1rem;

                &-title {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    margin-bottom: .1rem;

                    .text {
                        height: 0.7rem;
                        font-size: 0.75rem;
                        font-family: PingFang SC-Medium, PingFang SC;
                        font-weight: 500;
                        color: #000000;
                        line-height: 0.7rem;
                    }

                    .all {
                        width: 2.1rem;
                        height: 1rem;
                        border-radius: 0.65rem;
                        border: 0.05rem solid #000000;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-size: 0.6rem;
                        font-family: PingFang SC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #000000;
                    }
                }

                &-items {
                    display: flex;
                    flex-wrap: wrap;
                    justify-content: space-between;

                    .item {
                        margin-top: .5rem;
                        width: 5.2rem;
                        height: 2rem;
                        border-radius: 6.2rem;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-size: 0.6rem;
                        font-family: PingFang SC-Regular, PingFang SC;
                        font-weight: 400;
                        background: #F5F5F5;
                        color: #000;
                        transition: all .3s;

                        &.active {
                            background: #000;
                            color: #fff;
                        }

                        &.no-data {
                            height: 0;
                            margin: 0;
                            padding: 0;
                        }
                    }
                }
            }
        }

        .scroll-content-all {
            width: 100%;
            height: 80vh;
            overflow-y: auto;
            overflow-x: hidden;
            position: relative;
            padding: 0 0 5.9rem;

            .recommend {
                padding: 0 .8rem;
                margin-top: -.43rem;
                margin-bottom: 1rem;

                &-title {
                    height: 0.7rem;
                    font-size: 0.75rem;
                    font-family: PingFang SC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #000000;
                    line-height: 0.7rem;
                    margin-bottom: .1rem;
                }

                &-items {
                    display: flex;
                    flex-wrap: wrap;
                    justify-content: space-between;
                    width: calc(100% - .8rem);

                    .item {
                        margin-top: .5rem;
                        width: 3.7rem;
                        height: 2rem;
                        border-radius: 6.2rem;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-size: 0.6rem;
                        font-family: PingFang SC-Regular, PingFang SC;
                        font-weight: 400;
                        background: #F5F5F5;
                        color: #000;
                        transition: all .3s;

                        &.active {
                            background: #000;
                            color: #fff;
                        }

                        &.no-data {
                            height: 0;
                            margin: 0;
                            padding: 0;
                        }
                    }
                }
            }

            .index-tip {
                width: 2.4rem;
                height: 2.05rem;
                position: fixed;
                right: 1.5rem;
                top: 0;
                background: url("../../../assets/img/preview/index-tip.png");
                background-size: 100% 100%;
                margin-top: -1.025rem;
                display: flex;
                align-items: center;
                font-size: 1.1rem;
                justify-content: center;
                padding-right: .4rem;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #FFFFFF;
            }

            .van-index-bar.isMove {
                .van-index-bar__sidebar {
                    .van-index-bar__index {
                        //&::before {
                        //    display: block;
                        //    content: '';
                        //    width: 3rem;
                        //    height: .8rem;
                        //    position: absolute;
                        //    top: 0;
                        //    left: -3rem;
                        //}
                    }
                }
            }

            .van-index-bar__sidebar {
                padding-right: .35rem;

                .van-index-bar__index {
                    width: 0.6rem;
                    height: 0.6rem;
                    margin-top: .2rem;
                    padding: 0;
                    font-size: 0.5rem;
                    font-family: PingFang SC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #6B6C6C;
                    position: relative;

                    &.van-index-bar__index--active {
                        background: #000;
                        border-radius: 50%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        color: #fff;
                    }
                }

                &+div>div {
                    &:first-child {
                        visibility: hidden;
                    }
                }
            }

            .van-index-anchor {
                width: 14.47rem;
                height: 1.43rem;
                background: linear-gradient(90deg, #F5F5F5 0%, rgba(245, 245, 245, 0) 100%) !important;
                padding: 0 .8rem;
                font-size: 0.6rem;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #000000;
                display: flex;
                align-items: center;

                &::after {
                    display: none;
                }
            }

            .radio-item {
                display: flex;
                align-items: center;
                width: calc(100% - 1.6rem);
                height: 2.4rem;
                padding: 0 .75rem;

                .img {
                    width: 1rem;
                    height: 1rem;
                    margin-right: .55rem;
                    position: relative;

                    img {
                        width: 100%;
                        height: 100%;
                        transition: all .3s;
                        position: absolute;
                        left: 0;
                        top: 0;
                    }

                    .icon {
                        opacity: 1;
                    }

                    .icon-active {
                        opacity: 0;
                    }

                    &.active {
                        .icon {
                            opacity: 0;
                        }

                        .icon-active {
                            opacity: 1;
                        }
                    }
                }

                span {
                    font-size: 0.7rem;
                    font-family: PingFang SC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #000000;
                    flex: 1;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
            }
        }

        .bottom {
            position: absolute;
            width: 100%;
            left: 0;
            bottom: 0;
            padding: 0 .8rem .8rem;
            background: #fff;

            .selected-tags {
                width: 100%;
                height: 1.8rem;
                position: relative;
                align-items: center;

                .tag-items {
                    width: 100%;
                    height: 100%;
                    overflow: hidden;

                    .tag-items-content {
                        width: 100%;
                        height: 200%;
                        white-space: nowrap;
                        overflow-x: auto;
                        overflow-y: hidden;
                        padding-right: 4rem;

                        .tag-item {
                            margin-top: .3rem;
                            height: 1.2rem;
                            background: #F5F5F5;
                            border-radius: 1.2rem;
                            padding: 0 .2rem 0 .4rem;
                            display: inline-flex;
                            align-items: center;
                            margin-right: .4rem;

                            .text {
                                height: 0.6rem;
                                font-size: 0.6rem;
                                font-family: PingFang SC-Regular, PingFang SC;
                                font-weight: 400;
                                color: #000000;
                                line-height: 0.6rem;
                                margin-right: .2rem;
                                white-space: nowrap;
                                overflow: hidden;
                            }

                            .close {
                                width: 0.8rem;
                                height: 0.8rem;
                                background: rgba(118, 118, 128, 0.12);
                                border-radius: 50%;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                font-size: 0.7rem;
                                font-family: SF Pro-Semibold, SF Pro;
                                font-weight: 600;
                                color: rgba(60, 60, 67, 0.6);
                                line-height: 0.56rem;
                            }
                        }
                    }
                }

                .del {
                    width: 4.08rem;
                    height: 1.8rem;
                    background: linear-gradient(270deg, #fff 0%, #fff 50%, rgba(255, 255, 255, 0) 100%);
                    position: absolute;
                    top: 0;
                    right: 0;
                    display: flex;
                    align-items: center;
                    justify-content: flex-end;

                    img {
                        width: .8rem;
                        height: .8rem;
                        margin-right: .2rem;
                    }

                    span {
                        font-size: 0.6rem;
                        font-family: PingFang SC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #6B6C6C;
                    }
                }
            }

            .van-button {
                margin-top: .3rem;
                width: 100%;
                height: 2.2rem;
                border-radius: 1.2rem;
            }

            &.more {
                height: 5.1rem;
            }
        }
    }

    &.level {
        bottom: .8rem;
        width: calc(100% - 1.6rem);
        left: .8rem;
    }
}

.auction-filter {
    .trigger {
        display: flex;
        align-items: center;

        &.black {
            color: #000;
        }

        img {
            width: .7rem;
            height: .7rem;
            margin-right: .2rem;
        }

        span {
            height: 0.6rem;
            font-size: 0.6rem;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #6B6C6C;
            line-height: 0.6rem;
        }
    }
}
</style>
